import { useEffect, useContext } from 'react';
import { NBXStorage } from '@nbx/frontend-helpers/storage';
import { useAuthUser } from '@nbx/frontend-helpers/subscribe';
import { Context } from 'state/store';
import { setOverlay } from 'state/creators';

import OVERLAYS from 'constants/overlays';

export const useTermsOfServiceModal = () => {
  const [, dispatch] = useContext(Context);
  const user = useAuthUser();
  useEffect(() => {
    if (!user) return;
    NBXStorage.getItem(`TOS-ACCEPTED-${user?.email}`, {
      useLocalStorage: true
    }).then(isAcceptedTOS => {
      !isAcceptedTOS && console.log(`tos is need to be accepted by user=${user?.id}`);
      user && !isAcceptedTOS && dispatch(setOverlay(OVERLAYS.tos));
    });
  }, [dispatch, user]);
};
